import { AnyAction, createSlice } from '@reduxjs/toolkit';
import type { PayloadAction } from '@reduxjs/toolkit';

import { eventTracking } from '@/services/event-tracking';

import { IPartner, PartnerForm, PartnerFormPair } from '../model';
import { getEmptyPartner } from '../model/getEmptyPartner';
import { namespace as onboardingNamespace } from '../namespace';

const initialState: {
  data: IPartner;
} = {
  data: getEmptyPartner(),
};

const onboardingSlice = createSlice({
  name: onboardingNamespace,
  initialState,
  reducers: {
    setPartner: (state, action: PayloadAction<IPartner>) => {
      state.data = action.payload;

      if (state.data?.id) {
        eventTracking.setPartnerId(state.data.id);
      }
    },
    setPartnerCity: (state, action: PayloadAction<string>) => {
      state.data.cityId = action.payload;
    },
    updatePartner: (state, action: PayloadAction<Partial<IPartner>>) => {
      state.data = {
        ...state.data,
        ...action.payload,
      };
    },
  },
  extraReducers: builder => {
    builder.addMatcher(
      (action: AnyAction) => Boolean(action.error),
      (state, action) => {
        // action contains copy of error so we can not use instanceOf
        if (action.error?.name === 'PartnerBlockedError') {
          state.data.accessStatus = 'partner_blocked';
        }
      },
    );
  },
});

export type { PartnerForm, PartnerFormPair };
export { onboardingSlice, onboardingNamespace };
